import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { extraSmallSwatchBorderWidth, extraSmallSwatchPadding, shapes, swatchBorderWidth, swatchDiameters, swatchPadding, } from './constants';
import { SwatchPickerContext } from './SwatchPickerContext';
const defaultProps = {
    color: '',
    imageUrl: '',
};
const SwatchPickerDesign = ({ color = defaultProps.color, imageUrl = defaultProps.imageUrl, }) => {
    const { isLoading, shape, size, } = useContext(SwatchPickerContext);
    const swatchSize = useMemo(() => {
        const paddingSize = (size === 'xsmall'
            ? extraSmallSwatchPadding + extraSmallSwatchBorderWidth
            : swatchPadding);
        return (swatchDiameters[size] - (paddingSize * 2));
    }, [
        size,
    ]);
    const swatchDesignStyles = useMemo(() => (css `
        border-color: ${theme.colors.gray400};
        border-style: solid;
        border-width: ${styleUtils.rem(swatchBorderWidth)};
        display: block;
        height: ${styleUtils.rem(swatchSize)};
        width: ${styleUtils.rem(swatchSize)};
        ${color && css `
          background-color: ${color};
        `}
        ${shape === shapes.CIRCLE && css `
          border-radius: 100%;
        `}
        ${imageUrl && css `
          background-image: url(${imageUrl});
          background-size: cover;
        `}
        ${isLoading && css `
          opacity: ${styleUtils.disabledStateOpacity};
        `}
      `), [
        color,
        imageUrl,
        isLoading,
        shape,
        swatchSize,
    ]);
    return (_jsx("span", { css: swatchDesignStyles }));
};
const MemoizedSwatchPickerDesign = memo(SwatchPickerDesign);
export { MemoizedSwatchPickerDesign as SwatchPickerDesign };
